import axios from "axios";
import Cookies from "universal-cookie";
import { URL_Route } from "urlRouts";

export enum AxiosMethodEnum {
  post = "post",
  get = "get",
  delete = "delete",
}

// export const baseURL = "http://172.16.1.81:81";
export const baseURL = "https://apihome.delta.ir";

async function Axios(
  method: AxiosMethodEnum,
  url: string,
  obj?: object,
  contentType = "application/json"
) {
  const cookies = new Cookies();
  let config = {
    method: method,
    url: url,
    baseURL: baseURL + "/api/",
    headers: {
      Accept: "application/json",
      "Content-Type": contentType,
      Authorization: `Bearer ${cookies.get("token")}`,
    },
    data: {},
    params: {},
  };
  if (obj !== undefined) {
    if (method === AxiosMethodEnum.get) {
      config.params = obj;
    } else {
      config.data = obj;
    }
  }

  try {
    const { data: response } = await axios(config);
    let success = true;
    return { response, success };
  } catch (error: any) {
    if (error.response.status === 401) {
      window.location.href = URL_Route.Log_Out;
    }

    let success = false;
    let response = error.response.data;
    return { response, success };
  }
}

export default Axios;
